module.exports = __webpack_public_path__ + "static/bslGov_title-b6df13438bbb1367cf42ecd104f2d238.png";